import React from 'react';

import styled from '@emotion/styled';

import CopyIcon from '../Icons/CopyIcon';

interface ICopyKeyButton {
  apiKey: string;
  label?: string;
}

export const CopyKeyButton: React.FC<ICopyKeyButton> = ({ apiKey, label }) => {
  const [showCopied, setShowCopied] = React.useState(false);

  const handleCopyIconAreaClick = () => {
    navigator.clipboard.writeText(apiKey);
    setShowCopied(true);
    setTimeout(() => {
      setShowCopied(false);
    }, 1000);
  };

  return (
    <CopyIconAreaWrapper>
      <CopyIconArea onClick={handleCopyIconAreaClick}>
        {label ?? 'Copy Key'} <CopyIcon />
      </CopyIconArea>
      {showCopied && (
        <CopiedAnimation key={Date.now()}>Copied!</CopiedAnimation>
      )}
    </CopyIconAreaWrapper>
  );
};

const CopyIconAreaWrapper = styled.div`
  position: relative;
`;

const CopyIconArea = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px;
  cursor: pointer;
  border: 1px solid ${({ theme }) => theme.palette.borderColor};
  background-color: white;
  border-radius: 6px;
  width: 100%;
  height: 40px;
  color: ${({ theme }) => theme.palette.blueColor};
  gap: 8px;
  font-weight: 600;
  font-size: 14px;

  & > svg {
    color: ${({ theme }) => theme.palette.blueColor};
  }
`;

const CopiedAnimation = styled.div`
  position: absolute;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  font-size: 12px;
  font-weight: 600;
  color: ${({ theme }) => theme.palette.blueColor};
  white-space: nowrap;
  pointer-events: none;
  animation: slideUpFade 1s ease-out forwards;

  @keyframes slideUpFade {
    0% {
      opacity: 0.5;
      transform: translateX(-50%) translateY(0) scale(60%);
    }
    80% {
      opacity: 1;
    }
    100% {
      opacity: 0;
      transform: translateX(-50%) translateY(-30px) scale(100%);
    }
  }
`;
